<template>
  <div style="margin-top: -7rem !important;">
    <div class="page-header-card mb-3" :class="{ 'nav-orange-gradient-bg' : $getSiteId() == 33, 'nav-green-gradient-bg' : $getSiteId() == 35, 'nav-redish-gradient-bg' : $getSiteId() != 35 }">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-4 mt-5">
            <div class="vx-col w-full text-center">
              <custom-svg variant="user" width="60" height="60" color="white" />
            </div>
          </div>
          <div v-if="!formData.userFirstName && !formData.userLastName" class="vx-row">
            <div class="vx-col w-full text-center">
              <h2 style="color: white">profile</h2>
            </div>
          </div>
          <div v-else class="vx-row">
            <div class="vx-col w-full text-center">
              <h3 style="color: white; overflow: hidden; text-overflow: ellipsis;padding-inline: 2rem;">{{ formData.userFirstName }} {{ formData.userLastName }}</h3>
            </div>
            <div class="vx-col w-full text-center">
              <h6 style="color: white; overflow: hidden; text-overflow: ellipsis;padding-inline: 2rem;">{{ formData.email }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-overlay
      id="profile-overlay-background"
      no-center
      :show="overlayActive"
      variant="tranparent"
      opacity=0.85
      blur="5px"
    >
      <template #overlay>
        <div class="overlay-content text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="throb"></b-icon>
          <p id="cancel-label">Please wait...</p>
        </div>
      </template>

      <div id="profile-details" class="text-left mx-4">
        <div class="mb-2">
          <div role="group">
            <h5 class="ml-4">First Name</h5>
            <b-form-input
              v-model="formData.userFirstName"
              :state="firstNameState"
              aria-describedby="input-live-help input-live-feedback"
              trim
            ></b-form-input>

            <b-form-invalid-feedback id="input-live-feedback" class="ml-4">
              Your name is required
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="mb-2">
          <div role="group">
            <h5 class="ml-4">Last Name</h5>
            <b-form-input
              v-model="formData.userLastName"
              :state="lastNameState"
              aria-describedby="input-live-help input-live-feedback"
              trim
            ></b-form-input>

            <b-form-invalid-feedback id="input-live-feedback" class="ml-4">
              Your surname is required
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="mb-2">
          <h5 class="ml-4">Mobile</h5>
          <cleave
            v-model="formData.mobile"
            class="form-control"
            :raw="false"
            :options="options.prefix"
          />
        </div>
        <vs-divider><h5>Login Credentials</h5></vs-divider>
        <div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <p-check id="profile-change-password" class="ml-2 p-default p-curve p-fill p-icon p-smooth" v-model="changePassword" color="success">
                <i class="icon feather icon-check" slot="extra"></i>
                Change Password
              </p-check>
            </div>
          </div>
          <div class="vx-row pt-3" v-if="changePassword">
            <div class="vx-col w-full mb-2">
              <!-- <vs-input style="display: none;"/> -->
              <div role="group relative">
                <h5 class="ml-4">Password</h5>
                <b-form-input
                  id="profile-password"
                  v-model="formData.password"
                  type="password"
                  :state="passwordState"
                  aria-describedby="input-live-help input-live-feedback"
                  trim
                ></b-form-input>

                <b-form-invalid-feedback id="input-live-feedback" class="ml-4">
                  Your password should be a minimum of 8 characters
                </b-form-invalid-feedback>
              </div>
            </div>
            <div class="vx-col w-full" v-if="formData.password && passwordState">
              <div role="group">
                <h5 class="ml-4">Confirm Password</h5>
                <b-form-input
                  id="profile-password-confirm"
                  v-model="passwordConfirm"
                  type="password"
                  :state="passwordConfirmState"
                  aria-describedby="input-live-help input-live-feedback"
                  trim
                ></b-form-input>

                <b-form-invalid-feedback id="input-live-feedback" class="ml-4">
                  The passwords do not match
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
        <vs-divider><h5>Signature</h5></vs-divider>
        <div v-if="formData.signatureImageUrl">
          <img :src="formData.signatureImageUrl" width="100%">
          <div class="vx-row mt-2">
            <div class="vx-col w-full">
              <vs-button id="profile-remove-signature-button" class="mx-auto" type="border" color="danger" icon-pack="feather" icon="icon-x" @click="formData.signatureImageUrl = null; clearFilepond()">remove</vs-button>
            </div>
          </div>
        </div>
        <file-pond
          id="profile-signature-filepond"
          v-show="!formData.signatureImageUrl"
          ref="pond"
          :server="uploadLocation"
          label-idle="Drop image here or <span class='filepond--label-action'>Browse</span>"
          :allow-multiple="false"
          accepted-file-types="image/*"
          :instant-upload="true"
          allowPaste=false
          :allow-image-preview="true"
          @processfile="uploadComplete"
          @removefile="fileRemoved" />
        <vs-divider></vs-divider>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button :disabled="isSaveDisabled" id="profile-save-button" class="w-full" type="gradient" color="#20AA34" gradient-color-secondary="#97c360" icon-pack="feather" icon="icon-check" @click="saveChanges">save changes</vs-button>
          </div>
        </div>
        <vs-divider />
        <div class="vx-row mt-5">
          <div class="vx-col w-full mb-3">
            <vs-button id="profile-logout-button" class="w-full" type="border" color="warning" icon-pack="feather" icon="icon-log-out" @click="logout">log out</vs-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import Cleave from 'vue-cleave-component';
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
export default {
  components: {
    CustomSvg,
    Cleave,
    FilePond
  },
  data() {
    return {
      overlayActive: false,
      formData: {
        userFirstName: "",
        userLastName: "",
        password: "",
        mobile: "",
        email: "",
        signatureImageUrl: null,
        isStudent: true,
        isNewUiUpdate: true
      },
      passwordConfirm: "",
      options: {
        prefix: {
          blocks: [3, 3, 4],
          numericOnly: true,
        }
      },
      changePassword: false
    };
  },
  watch: {
    changePassword: function(val) {
      if (!val) {
        this.formData.password = "";
        this.passwordConfirm = "";
      }
    }
  },
  computed: {
    isSaveDisabled() {
      var self = this;

      if (!self.firstNameState || !self.lastNameState || (self.changePassword && (!self.passwordState || !self.passwordConfirmState)) || !self.formData.mobile) {
        return true;
      }

      return false;
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    firstNameState() {
      return this.formData.userFirstName.length > 0 ? true : false
    },
    lastNameState() {
      return this.formData.userLastName.length > 0 ? true : false
    },
    passwordState() {
      return this.formData.password.length > 7 ? true : false
    },
    passwordConfirmState() {
      return this.passwordConfirm.length > 0 && (this.formData.password == this.passwordConfirm) ? true : false
    }
  },
  methods: {
    loadData() {
      var self = this;
      self.overlayActive = true;

      var onSuccess = function (response) {
        self.formData.id = response.data.id;
        self.formData.userFirstName = response.data.userFirstName;
        self.formData.userLastName = response.data.userLastName;
        self.formData.mobile = response.data.mobile;
        self.formData.email = response.data.email;
        self.formData.signatureImageUrl = response.data.signatureImageUrl;
      };
      var onFinally = function() {
        self.overlayActive = false;
      };
      
      self.$ajaxGet(self, "Student/GetInfoSkinny", onSuccess, onFinally);
    },
    saveChanges(){
      var self = this;

      if(self.formData.signatureImageUrl){
        self.saveChangesWithRightSignature();
        var userSiteInfo;
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
          userSiteInfo = JSON.parse(localStorage.getItem('userSiteInfo'));
          userSiteInfo[0].hasSignature = true;
          localStorage.setItem('userSiteInfo', JSON.stringify(userSiteInfo));
        }
        else{
          userSiteInfo = JSON.parse(localStorage.getItem('userSiteInfo'))
          userSiteInfo.hasSignature = true;
          localStorage.setItem('userSiteInfo', JSON.stringify(userSiteInfo));
        }
      }
      else{
        self.saveChangesWithRightSignature();
      }
    },
    saveChangesWithRightSignature() {
      var self = this;
      self.overlayActive = true;

      var onSuccess = response => {
        self.overlayActive = false;
        self.$swal({
          position: 'center',
          icon: 'success',
          title: "Information updated!",
          showConfirmButton: false,
          timer: 2000
        });
      };
      var onFinally = function () {
        self.overlayActive = false;
      };
      
      self.$ajaxPost(self, "student/savechanges", self.formData, onSuccess, onFinally);
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.signatureImageUrl = response.url;
    },
    fileRemoved(error, file) {
      this.formData.signatureImageUrl = null;
    },
    clearFilepond(){
      var self = this;
      if(this.$refs.pond){
        self.$refs.pond.getFiles().forEach(element => {
          self.$refs.pond.removeFile(element);
        });
      }
    },
    logout() {
      this.$endUserSession();
      
      let routeData = this.$router.resolve({ path: '/login' });
      window.open(routeData.href, '_self');
      
      localStorage.removeItem("userInfo");
      this.$acl.change("");
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      localStorage.setItem("currentModule", "");
      localStorage.setItem("isStudent", "false");
    },
  },
  mounted() {
    this.loadData();
  }
};
</script>